/// <amd-module name="Environments/EnvironmentTraceabilityChanges/Actions/CommitsActions" />
import { ActionsHubBase, Action } from "Environments/Flux/ActionCreatorBase";
import { ICommitsResult } from "Environments/Client/EnvironmentContracts";

export class CommitsActions extends ActionsHubBase {

    public static getKey(): string {
        return "commits-actions";
    }

    public initialize(instanceId?: string) {
        this._setCommits = new Action<ICommitsResult>();
    }

    public get setCommits(): Action<ICommitsResult> {
        return this._setCommits;
    }

    private _setCommits: Action<ICommitsResult>;
}
